import styled from '@emotion/styled'
import { Box, Typography } from '@mui/material'

export const PopupWrapper = styled(Box)(`
	width: 100%;
	height: 100vh;
	padding: 80px;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 100;
	overflow: auto;
	background: rgba(0, 0, 0, 0.3);
`)

export const GraphOuterWrapper = styled(Box)(`
	padding:15px 25px;
	background: #fff;
	display: flex;
	flex-wrap: wrap;
	border-radius: 0 0 8px 8px;
	min-height: 500px;
    align-content: baseline;
`)

export const HeaderWrapper = styled(Box)(`
	border-radius: 8px 8px 0 0;
	padding:15px 25px;
	background: #F6F6F5;
	display: flex;
	justify-content: space-between;
`)

export const TitleWrapper = styled(Box)(`
	display: flex;
	justify-content: space-between;
	width:100%;
`)

export const Title1 = styled(Box)(`
	font-size: 19px;
	line-height: 28px;
	font-weight: 400; // 300;
`)

export const Title2 = styled(Box)(`
	font-size: 12px;
	line-height: 28px;
	font-weight: 400;
`)

export const Lhs = styled(Box)(`
	display: flex;
	justify-content: start;
	align-items: center;
	gap: 8px;

	& .selectWrap .MuiSelect-select {
	padding-right: 20px !important;
    max-width: 215px;
  }
`)
export const DriverTitle = styled(Box)(`
	color: #454545;
	font-size: 12px;
	font-weight: 600;
	line-height: 16px;
`)
export const Rhs = styled(Box)(`
	display: flex;
	justify-content: end;
	& button {
		margin-left: 12px;
	}

  & .MuiBox-root button {
		margin-left : 0;
	}
`)

export const LegendWrapper = styled(Box)(`
	padding: 20px 0 15px 0;
	width: 100%;
	display:flex;
	justify-content: center;
`)

export const StackedGraphWrapper = styled(Box)(`
	padding: 20px;
	width: 100%;
	border: 1px solid #E0E0DE;
	border-radius: 5px;
	margin-top:10px;
	position: relative;
	height: 300px;
	
	& p { font-size: 12px; }
	& .noDataFound { right:auto; max-width: 235px; left: calc(50% - 115px); }
`)
